import React from 'react';
import PageHeader from '../../components/Page-Header';
import './styles.css';
import MentorCard from '../../Mentor-card';

const Mentors = () => {
  return (
    <div id="page-mentors-list" className="container">
      <PageHeader />
      <div className="mentors-cards">
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
        <MentorCard 
          name="Rafael Akiyoshi"
          description="Software Engineer"
          bio="O empenho em analisar a estrutura atual da organização nos obriga à análise dos conhecimentos estratégicos para atingir a excelência. Neste sentido, o fenômeno da Internet assume importantes posições no estabelecimento das regras de conduta normativas."
          photo="https://avatars2.githubusercontent.com/u/11548256?s=460&u=b7e5abe5d147a04e35ba5cf37908df7031a8f697&v=4" 
          contact="vem de zap"
          price="35,00"
        />
      </div>
    </div>
  );
}

export default Mentors;